import type { CoreRequest } from '$api-clients/hooks';
import type { AgentSelectOption } from '$form-fields';
import type { BuyerAgreementType } from './components/types';

export type ClientGroup =
  CoreRequest<'/client-groups'>['Data']['results'][number];

export enum BuyerMethod {
  existingBuyer = 'existing-buyer',
  newBuyer = 'new-buyer',
  unrepresentedBuyer = 'unrepresented-buyer',
}

/**
 * Labels and descriptions for the buyer-type step tiles, keyed by the
 * buyer method they select.
 */
export const buyerMethodOptions: Record<
  BuyerMethod,
  { label: string; description: string }
> = {
  [BuyerMethod.existingBuyer]: {
    label: 'Existing Buyer',
    description:
      "Link a buyer and their agreement that's already saved in Side",
  },
  [BuyerMethod.newBuyer]: {
    label: 'New Buyer',
    description:
      'Create a new buyer contact and agreement directly from this offer',
  },
  [BuyerMethod.unrepresentedBuyer]: {
    label: 'Unrepresented Buyer',
    description:
      "The buyer has no agent and won't need a representation agreement",
  },
};

interface BuyerClient {
  firstName?: string;
  lastName?: string;
  email?: string;
  entityType?: string;
  [key: string]: unknown;
}

export interface CreateOfferFormData {
  buyerAgents?: AgentSelectOption[];
  newBuyerClients?: BuyerClient[];
  buyer?: ClientGroup | null;
  buyerMethod?: BuyerMethod;
  sellerAgent?: AgentSelectOption;
  type?: BuyerAgreementType;
  attachment?: File[];
  street1?: string;
  street2?: string;
  city?: string;
  state?: string;
  zip?: string;
  county?: string;
  mlsNumber?: string;
  mlsServiceId?: string;
  // Set when the selected address matches one of the user's own listings, so
  // the offer can be linked to that listing on creation (CORE-16747).
  listingId?: string;
  [key: string]: unknown;
}
